/**
 * Determine whether the element is in the visual range
 *
 * @param  {HTMLElement} the HTML object
 * @return {boolean} is the element in the visual range
 */
export const isInView = (el: HTMLElement): boolean => {
    const coefficient = 0.1;
    const wHeight = window.innerHeight || document.documentElement.clientHeight;
    const wWidth = window.innerWidth || document.documentElement.clientWidth;
    // tslint:disable-next-line: prefer-const
    let { top, bottom, left, right, height, width } = el.getBoundingClientRect();
    height = height || el.offsetHeight;
    width = width || el.offsetWidth;
    bottom = wHeight - bottom;
    right = wWidth - right;
    let insideHeight = 0;
    let insideWidth = 0;
    // insideHeight
    if (top > -1 * height && top < 0) { insideHeight = top + height; }
    else if (bottom > -1 * height && bottom < 0) { insideHeight = bottom + height; }
    else if (bottom >= 0 && top >= 0) { insideHeight = height; }
    else { return false; }
    // insideWidth
    if (left > -1 * width && left < 0) { insideWidth = left + width; }
    else if (right > -1 * width && right < 0) { insideWidth = right + width; }
    else if (right >= 0 && left >= 0) { insideWidth = width; }
    else { return false; }
    // inside area
    const insideArea = insideHeight * insideWidth;
    return insideArea >= width * height * coefficient;
};



// WEBPACK FOOTER //
// ./src/utils/isInView.ts